import { buttonSettings } from './Button/settings';
import { anchorSettings } from './Anchor/settings';
import { bodyTextSettings } from './BodyText/settings';
import { headingSettings } from './Heading/settings';
import { inputMessageSettings } from './InputMessage/settings';
import { inputSettings } from './Input/settings';
import { tooltipSettings } from './Tooltip/settings';
import { progressBarSettings } from './ProgressBar/settings';
import { toggleSettings } from './Toggle/settings';
import { checkboxSettings } from './Checkbox/settings';
import { subscriptionComponentCardSettings } from './SubscriptionComponentCard/settings';
import { selectSettings } from './Select/settings';
import { radioButtonSettings } from './RadioButton/settings';
import { optionsSettings } from './Options/settings';
import { textAreaSettings } from './TextArea/settings';

const atomsSettings = {
  Button: buttonSettings,
  Anchor: anchorSettings,
  BodyText: bodyTextSettings,
  Heading: headingSettings,
  InputMessage: inputMessageSettings,
  Input: inputSettings,
  Tooltip: tooltipSettings,
  Toggle: toggleSettings,
  ProgressBar: progressBarSettings,
  Checkbox: checkboxSettings,
  SubscriptionComponentCard: subscriptionComponentCardSettings,
  Select: selectSettings,
  RadioButton: radioButtonSettings,
  Options: optionsSettings,
  TextArea: textAreaSettings,
};

export default atomsSettings;
